import React from 'react';
import './ChronosGeoPage.css';

// IMPORTACIÓN DE IMÁGENES LOCALES
import img1 from '../fotos_chronos_geo/1.png';
import img2 from '../fotos_chronos_geo/2.png';
import img3 from '../fotos_chronos_geo/3.png';
import img4 from '../fotos_chronos_geo/4.png';
import imgA from '../fotos_chronos_geo/A.png';
import imgB from '../fotos_chronos_geo/B.png';

const ChronosGeoPage = () => {
  return (
    <div className="chronos-container">
      
      {/* 1. HERO SECTION */}
      <section className="chronos-hero">
        <div className="chronos-hero-content">
          <div className="chronos-badge">CHRONOS EYE LABS</div>
          <h1>CHRONOS GEO</h1>
          <p>El fin de la ceguera operativa. Ore Control y Modelamiento 3D en tiempo real, 100% offline.</p>
          
          <div className="chronos-hero-buttons">
            <a href="https://wa.me/51963462787?text=Hola,%20quiero%20solicitar%20una%20demo%20de%20Chronos%20Geo" target="_blank" rel="noopener noreferrer" className="btn-chronos-primary">
              Solicitar Demo
            </a>
            <a href="#caracteristicas" className="btn-chronos-secondary">
              Ver Características
            </a>
          </div>
        </div>

        <div className="chronos-hero-media">
          <img src={img1} alt="Chronos Geo App" className="hero-main-image" />
        </div>
      </section>

      <div id="caracteristicas"></div>

      {/* 2. FEATURE 1: EL PODER DE LA ADAPTABILIDAD (img2) */}
      <section className="chronos-feature-section">
        <div className="feature-content left-text">
          <div className="feature-text-block">
            <h2>El Poder de la Adaptabilidad</h2>
            <p>
              Una suite de cálculo de bolsillo para respuestas inmediatas en campo. Simula mezclas operativas (Blending), 
              calcula el espesor verdadero y evalúa leyes equivalentes directamente en el modelo 3D. 
              Todo respaldado por una arquitectura <strong>Edge-Optimized</strong> que procesa millones de bloques 
              sin drenar la batería de tu dispositivo.
            </p>
            <ul className="chronos-feature-list">
              <li><i className="fas fa-check-circle"></i> Cut-off dinámico y simulador de rentabilidad.</li>
              <li><i className="fas fa-check-circle"></i> Hoja de cálculo integrada con parser de fórmulas.</li>
              <li><i className="fas fa-check-circle"></i> Planos georreferenciados haciendo match en campo.</li>
            </ul>
          </div>
          <div className="feature-visual-block">
            <img src={img2} alt="El poder de la adaptabilidad" />
          </div>
        </div>
      </section>

      {/* 3. FEATURE 2: DONDE TERMINA LA SEÑAL (img3) */}
      <section className="chronos-feature-section bg-darker">
        <div className="feature-content right-text">
          <div className="feature-visual-block">
            <img src={img3} alt="Donde termina la señal comienza tu visión" />
          </div>
          <div className="feature-text-block">
            <h2>Donde termina la señal, comienza tu visión</h2>
            <p>
              Diseñado específicamente para entornos desconectados. Realiza cortes ortogonales (Smart Slicing), 
              evalúa celdas parciales para obtener tonelajes reales y reconcilia volúmenes al instante. 
              Tu cuaderno de campo ahora es 100% digital, tridimensional y colaborativo.
            </p>
            <ul className="chronos-feature-list">
              <li><i className="fas fa-check-circle"></i> Funcionamiento 100% Offline.</li>
              <li><i className="fas fa-check-circle"></i> Bookmarks espaciales y recuperación de contexto.</li>
              <li><i className="fas fa-check-circle"></i> Evaluación en el sitio y análisis de polígonos.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 4. FEATURE 3: ECOSISTEMA INTELIGENTE (imgA - Tríptico 1) */}
      <section className="chronos-feature-section">
        <div className="feature-content left-text">
          <div className="feature-text-block">
            <h2>Ecosistema Inteligente de Operación Minera</h2>
            <p>
              Transformamos tu celular en una estación de ingeniería avanzada. Se acabó redactar reportes manuales; 
              al evaluar un polígono, la aplicación captura el entorno 3D y genera un <strong>"Paquete Minero"</strong> automatizado.
            </p>
            <ul className="chronos-feature-list">
              <li><i className="fas fa-check-circle"></i> Reportes formales en PDF con datos de reconciliación.</li>
              <li><i className="fas fa-check-circle"></i> Mallas DXF listas para Datamine, Vulcan o Leapfrog.</li>
              <li><i className="fas fa-check-circle"></i> Exportación inmediata vía WhatsApp o Email.</li>
            </ul>
          </div>
          <div className="feature-visual-block triptych-container">
            <img src={imgA} alt="Ecosistema Inteligente" />
          </div>
        </div>
      </section>

      {/* 5. FEATURE 4: IMPACTO OPERATIVO (imgB - Tríptico 2) */}
      <section className="chronos-feature-section bg-darker">
        <div className="feature-content right-text">
          <div className="feature-visual-block triptych-container">
            <img src={imgB} alt="Impacto Operativo" />
          </div>
          <div className="feature-text-block">
            <h2>Impacto Operativo y Seguridad Empresarial</h2>
            <p>
              Logra una reducción del 60% en tiempos de respuesta. Tu información está blindada con 
              licenciamiento criptográfico vinculado al hardware del dispositivo, impidiendo accesos no autorizados.
            </p>
            <ul className="chronos-feature-list">
              <li><i className="fas fa-check-circle"></i> Watchdog de suscripción en tiempo real.</li>
              <li><i className="fas fa-check-circle"></i> Telemetría transparente y sincronización asíncrona.</li>
              <li><i className="fas fa-check-circle"></i> Soporte universal de formatos (CSV, XLSX, DXF).</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 6. FEATURE 5: FUTURAS FUNCIONES (img4) */}
      <section className="chronos-feature-section">
        <div className="feature-content left-text">
          <div className="feature-text-block">
            <h2>Innovación Continua: El Futuro de la Exploración</h2>
            <p>
              No nos detenemos. Estamos desarrollando capacidades de inmersión total e Inteligencia Artificial 
              para llevar la comprensión del yacimiento a un nivel sin precedentes.
            </p>
            <ul className="chronos-feature-list">
              <li><i className="fas fa-check-circle"></i> Integración con Gafas VR para visualización inmersiva.</li>
              <li><i className="fas fa-check-circle"></i> Modo Exploración (Avatar) para recorrer galerías a escala real.</li>
              <li><i className="fas fa-check-circle"></i> Auditoría de base de datos impulsada por IA.</li>
            </ul>
          </div>
          <div className="feature-visual-block">
            <img src={img4} alt="Futuras Funciones" />
          </div>
        </div>
      </section>

      {/* 7. BOTTOM CTA */}
      <section className="chronos-bottom-cta">
        <h2>Lleva el modelo de bloques en el bolsillo.</h2>
        <p>Deja la laptop en la oficina. Decide en campo y actúa en tiempo real.</p>
        <div className="chronos-hero-buttons">
          <a href="https://wa.me/51963462787?text=Hola,%20quiero%20implementar%20Chronos%20Geo%20en%20mi%20operación" target="_blank" rel="noopener noreferrer" className="btn-chronos-primary">
            Contactar a un Experto
          </a>
        </div>
      </section>

    </div>
  );
};

export default ChronosGeoPage;